import React, {ChangeEvent, useMemo, useCallback, useState, useEffect} from 'react';
import styles from './TicketInput.module.scss';
import '../customStyle.css';
import { SelectOption } from '@src/types';
import DropDownIcon from 'src/assets/icons/dropup.svg?react';


export type TextInputValue = string | number;
export type TextInputChange = (value: TextInputValue) => void;

export const timeOptions: SelectOption[] = [
  {label: "Hours", value: "Hours"},
  {label: "Days", value: "Days"}
]

type Props = {
  label: string;
  id: string;
  value: TextInputValue;
  type?: 'text' | 'password' | 'date' | 'number';
  placeholder?: string;
  className?: string;
  onChange: TextInputChange;
  inline?: boolean;
  hasError?: boolean;
  subTitle?: string | React.ReactNode;
  min?: string;
  readonly?: boolean;
  autoFocus?: boolean;
  setTimeChange?: (label: string) => void
  closeMenu?: boolean;
};

export const TicketInput = (props: Props) => {
  const { label, id, placeholder, value, onChange, setTimeChange, className, inline, hasError, subTitle, min, readonly, autoFocus, closeMenu=false } = props;

  const [timeSlot, setTimeSlot] = useState(false);
  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };
  useEffect(() => {
    if (!!closeMenu) {
      setTimeSlot(false)
    }
  }, [closeMenu])
  const classes = useMemo(() => {
    const classes = [styles.wrapper, className];
    if (inline) {
      classes.push(styles.inline);
    }
    if (value) {
      classes.push(styles.hasValue);
    }
    if (hasError) {
      classes.push(styles.error);
    }
    return classes.join(' ').trim();
  }, [className, value, inline, hasError]);

  const handleChangeSelect = useCallback((opt: any) => {
    if(setTimeChange) setTimeChange(opt)
    setTimeSlot(false)
  }, [setTimeChange]);

  const showTimeMenu = (e: any) => {
    e.stopPropagation()
    setTimeSlot(current => !current);
  }

  return (
    <div className={classes}>
      <div className={styles.content}>
        <input autoFocus={autoFocus} readOnly={readonly} onChange={handleChange} value={value} placeholder={placeholder} className={styles.input} id={id}
           min={min} inputMode="numeric" type="number" />
        {label === "Exit Tickets" || label === "Surveys" || label === "Students" ? <div className={styles.nameErea}>{value === 1 && label === "Students" ? 'Student' : label}</div> :
        <div className={styles.timeLabelErea} onClick={showTimeMenu}>
          <div className={styles.timeLabel}>{label}</div>
          <DropDownIcon className={styles.dropIcon} width={12} height={10}/>
        </div>
        }
        <div className={styles.dropDownActiveMenu} style={{display: timeSlot ? "block" : "none"}}>
          <div className={styles.dropDownMenuitem} onClick={() => {handleChangeSelect('Hours')}}>
            {'Hours'}
          </div>
          <div className={styles.dropDownMenuitem} onClick={() => {handleChangeSelect('Days')}}>
            {'Days'}
          </div>
        </div>
      </div>
      {subTitle && <div className={styles.subtitle}>{subTitle}</div>}
    </div>
  );
};
